export default __webpack_public_path__ + "static/media/apricityTextLogo.78626cde.png";